import React from "react"
import clsx from "clsx"

// Sizes in pixels: the legacy stylesheet turns w-5 into 5 % of the parent.
const SIZES = {
  xs: "w-[20px] h-[20px] text-[9px]",
  sm: "w-[24px] h-[24px] text-[10px]",
  md: "w-[32px] h-[32px] text-[11px]",
}

const Avatar = ({ user, size = "sm", className, title, plain = false }) => {
  if (!user) {
    return (
      <span
        title={title || I18n.t("project_planning.unknown_person")}
        className={clsx("inline-grid place-items-center rounded-full shrink-0 border border-dashed border-slate-300 bg-slate-50 text-slate-400 font-semibold", SIZES[size], className)}
      >
        ?
      </span>
    )
  }
  return (
    <span
      title={title || user.name}
      style={plain ? undefined : { backgroundColor: user.color || "#64748B" }}
      className={clsx(
        "inline-grid place-items-center rounded-full shrink-0 font-semibold tracking-tight",
        plain ? "bg-white text-slate-800 ring-1 ring-black/10" : "text-white",
        SIZES[size], className,
      )}
    >
      {user.initials}
    </span>
  )
}

export default Avatar
